import logo from "./logo.svg";
import "./App.css";
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./modules/login/login";
import api, { deleteAllCookies, getCookie } from "../src/api_interceptor/api";
import { useDispatch } from "react-redux";
import { persistor } from "./redux/store/Store";
import DashboardLayout from "./modules/dashboard/DashboardLayout";
import Clients from "./modules/clients/Clients.jsx";
import Roles from "./modules/roles/Roles.jsx";
import Activities from "./modules/activities/Activities.jsx";
import ClientForm from "./modules/clients/ClientForm.jsx";
import RolesForm from "./modules/roles/RolesForm.jsx";
import MealServices from "./modules/mealServices/MealServices.jsx";
import MealServicesForm from "./modules/mealServices/MealServicesForm.jsx";
import Diets from "./modules/diets/Diets.jsx";
import DietsForm from "./modules/diets/DietsForm.jsx";
import Recipients from "./modules/recipients/Recipients.jsx";
import RecipientsForm from "./modules/recipients/RecipientsForm.jsx";
import Occasions from "./modules/occasions/Occasions.jsx";
import OccasionsForm from "./modules/occasions/OccasionsForm.jsx";
import Allergens from "./modules/allergens/Allergens.jsx";
import AllergensForm from "./modules/allergens/AllergensForm.jsx";
import HelpManual from "./modules/helpManual/HelpManual.jsx";
import SectionForm from "./modules/helpManual/SectionForm.jsx";
import TopicForm from "./modules/helpManual/TopicForm.jsx";

function App() {
  return (
    // <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <p>
    //       Edit <code>src/App.js</code> and save to reload.
    //     </p>
    //     <a
    //       className="App-link"
    //       href="https://reactjs.org"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Learn React
    //     </a>
    //   </header>
    // </div>

    <Router>
      <Routes>
        {/* {!isLoggedIn && <Route exact path="/" element={<Login showPopUpModal={showPopUp} />}></Route> }
          {isLoggedIn && <Route exact path="/" element={<Dashboard/>}></Route>} */}
        <Route path="/" element={<Login />} />

        <Route element={<DashboardLayout />}>
          <Route path="/clients" element={<Clients />} />
          <Route path="/roles" element={<Roles />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/clients/add" element={<ClientForm />} />
          <Route path="/clients/edit/:id" element={<ClientForm />} />
          <Route path="/roles/add" element={<RolesForm />} />
          <Route path="/roles/edit/:id" element={<RolesForm />} />
          <Route path="/meal-services" element={<MealServices />} />
          <Route path="/meal-services/add" element={<MealServicesForm />} />
          <Route path="/meal-services/edit/:id" element={<MealServicesForm />} />
          <Route path="/diet-master" element={<Diets />} />
          <Route path="/diet-master/add" element={<DietsForm />} />
          <Route path="/diet-master/edit/:id" element={<DietsForm />} />
          <Route path="/recipient-master" element={<Recipients />} />
          <Route path="/recipient-master/add" element={<RecipientsForm />} />
          <Route path="/recipient-master/edit/:id" element={<RecipientsForm />} />
          <Route path="/occasion-master" element={<Occasions />} />
          <Route path="/occasion-master/add" element={<OccasionsForm />} />
          <Route path="/occasion-master/edit/:id" element={<OccasionsForm />} />
          <Route path="/allergen-master" element={<Allergens />} />
          <Route path="/allergen-master/add" element={<AllergensForm />} />
          <Route path="/allergen-master/edit/:id" element={<AllergensForm />} />
          <Route path="/helpmanual" element={<HelpManual />} />
          <Route path="/helpmanual/sections/add" element={<SectionForm />} />
          <Route
            path="/helpmanual/sections/edit/:sectionId"
            element={<SectionForm />}
          />
          <Route
            path="/helpmanual/topics/add/:sectionId"
            element={<TopicForm />}
          />
          <Route
            path="/helpmanual/topics/edit/:sectionId/:topicId"
            element={<TopicForm />}
          />
        </Route>

        {/* <Route path="/viewupdatehistory/" element={<ViewUpdateHistory />} />
          <Route path="/finalpreview/" element={<FinalPreview />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
